/**
 * Greentic Google Analytics/Adwords Plugin
 * @author romain@greentic.net
 */
;(function($) {
"use strict";
/**
 * Google Analytics
 */
$(function() {
    var events = ["click", "change", "blur", "submit", "mouseover", "mouseenter", "mouseleave"];
    var ns = "ga";
    $.each(events, function() {
        $(document).on(this + "." + ns, "[data-" + ns + "-event='" + this + "']", function(event) {
            var $self = $(this);
            var callback = $self.data(ns + "-callback");
            var options = {
                category: $self.data(ns + "-category"),
                action: $self.data(ns + "-action"),
                label: $self.data(ns + "-label"),
                value: $self.data(ns + "-value")
            };
            if (!callback || callback.call(this, options, event)) {
                ga && ga("send", "event", {
                    eventCategory: options.category,
                    eventAction: options.action,
                    eventLabel: options.label,
                    eventValue: options.value
                });
            }
        });
    });
});
/**
 * Google Adwords
 */
$(function() {
    var events = ["click", "change", "blur", "submit", "mouseover", "mouseenter", "mouseleave"];
    var ns = "adwords";
    $.each(events, function() {
        $(document).on(this + "." + ns, "[data-" + ns + "-event='" + this + "']", function(event) {
            var $self = $(this);
            var callback = $self.data(ns + "callback");
            var options = {
                id: $self.data(ns + "-conversion-id"),
                label: $self.data(ns + "-conversion-label")
            };
            if (!callback || callback.call(this, options, event)) {
                (new Image()).src = "//www.googleadservices.com/pagead/conversion/" + options.id + "/?label=" + options.label;
            }
        });
    });
});
})(jQuery);